// eslint-disable-next-line import/no-anonymous-default-export
export default {
  v1: "https://movein.theatro360.com/api",
  v2: "https://manage.theatro360.com/api/v2",
};
